import Drawer from "../common/Drawer";
import { initSwiper } from "../common/init-swiper";
import { ajax } from "../utils";
import Modal from "./Modal";
import { initOffuscation } from "./link-offuscation";

class ReviewsFiltering {
  constructor() {
    this.wrapper = document.querySelector(".wrapper-reviews");
    if(this.wrapper){
      const _this = this;

      this.reviewsDrawer = this.wrapper.querySelector('.reviews-drawer');
      this.reviewsContainer = this.wrapper.querySelector('#reviews-pagination-container');
      if(this.reviewsContainer){
        this.sortBy = 'created';
        this.activeFilters = 0;
        this.previousUrlWithParams = '';
        this.activeFiltersBadge = this.wrapper.querySelector('#active-filters-count');

        if(this.reviewsDrawer){
          this.initSortBy();

          this.filterButton = this.reviewsDrawer.querySelector('#filter-reviews');
          this.typesOfExperience = this.reviewsDrawer.querySelectorAll("[name='activity']");
          this.langs = this.reviewsDrawer.querySelectorAll("[name='lang']");
          this.visitorsNotes = this.reviewsDrawer.querySelectorAll("[name='note']");

          if(this.filterButton && this.typesOfExperience && this.langs && this.visitorsNotes){
            this.initFiltering();
          }

          //reset the filters and refetch the initial view of the reviews block
          this.resetButton = this.reviewsDrawer.querySelector('#reset-filters');
          this.defaultRadioInputs = this.reviewsDrawer.querySelectorAll('input.default');
          if(this.resetButton && this.defaultRadioInputs){
            this.initReset();
          }
        }

        //all pagination related
        this.initPagination();
      }

      this.initViewHostReply();

      this.overlayLoading = this.wrapper.querySelector('.overlay-loading');

      this.translateReviewsButton = this.wrapper.querySelector('#translate-reviews');
      if(this.translateReviewsButton){
        this.translatedByGoogleNotice = this.wrapper.querySelector('#translatedByGoogle');
        this.translateReviewsButton.addEventListener('click', () => _this.onTranslateButtonClick());
      }
    }
  }

  initFiltering(){
    //perform the ajax request to get the view depending on the filters when filter button clicked
    this.filterButton.addEventListener('click', () => {
      this.fetchReviews(
        this.wrapper.dataset.experienceId ?? 0,
        this.wrapper.dataset.hostId ?? 0,
        this.wrapper.dataset.giftPackageId ?? 0,
        1
      );
    });
  }

  initReset(){
    this.resetButton.addEventListener('click', () => {
      //first, put back default values on filters
      this.defaultRadioInputs.forEach(input => input.checked = true);
      //also make sure that the sort by is resetted to its default value
      this.sortBy = 'created';

      //then, remove any checked values from types of experience or langs
      if(this.typesOfExperience)
        this.typesOfExperience.forEach(input => input.checked = false);

      //same with langs
      if(this.langs)
        this.langs.forEach(input => input.checked = false);

      //finally, trigger the filtering
      this.fetchReviews(
        this.wrapper.dataset.experienceId ?? 0,
        this.wrapper.dataset.hostId ?? 0,
        this.wrapper.dataset.giftPackageId ?? 0,
        1
      );
    });
  }

  //init click on different pages, as well as next/previous buttons
  initPagination(){
    this.pagination = this.wrapper.querySelector('.custom-paginator');
    if(this.pagination){
      this.activePage = this.pagination.querySelector('.page.active');
      this.pages = this.pagination.querySelectorAll('.page');
      this.pages.forEach((page) => {
        page.addEventListener('click', () => this.onPageClick(page));
      });

      this.next = this.pagination.querySelector('.next');
      if(this.next) this.next.addEventListener('click', () => this.onPreviousOrNextClick('next'));

      this.previous = this.pagination.querySelector('.previous');
      if(this.previous) this.previous.addEventListener('click', () => this.onPreviousOrNextClick('previous'));
    }
  }

  //get filters from the drawer
  getCustomFilters(){
    if(!this.typesOfExperience || !this.langs || !this.visitorsNotes){
      return {
        typesOfExperiences: [],
        langs: [],
        note: []
      };
    }

    //first, get types of experience
    let typesOfExperiences = [];
    this.typesOfExperience.forEach(input => {
      if(input.checked){
        typesOfExperiences.push(input.value);
      }
    });

    //then, get langs
    let langs = [];
    this.langs.forEach(input => {
      if(input.checked){
        langs.push(input.value);
      }
    });

    //finally, get visitor rating
    let note = [];
    this.visitorsNotes.forEach(input => {
      if(input.checked){
        note.push(input.value);
      }
    });

    return {
      typesOfExperiences: typesOfExperiences,
      langs: langs,
      note: note
    };
  }

  onPageClick(page){
    this.fetchReviews(
      this.wrapper.dataset.experienceId ?? 0,
      this.wrapper.dataset.hostId ?? 0,
      this.wrapper.dataset.giftPackageId ?? 0,
      page.dataset.num
    );
  }

  fetchReviews(experience_id, host_id, gift_package_id, num){
    let url = new URL(this.wrapper.dataset.url);
    let params = url.searchParams;
    params.append("experienceId", experience_id);
    params.append("hostId", host_id);
    params.append("giftPackageId", gift_package_id);
    params.append("page", num);
    params.append("sortby", this.sortBy);
    let localeTranslation = !!this.wrapper.getAttribute("data-translate-to-locale");
    if(localeTranslation){
      params.append("locale", this.wrapper.dataset.translateToLocale);
    }

    //get the query parameters / filters to pass to the view
    const filters = this.getCustomFilters();
    if(filters.typesOfExperiences.length){
      filters.typesOfExperiences.forEach(value => {
        params.append("activities_id[]", value);
      });
    }
    if(filters.langs.length){
      filters.langs.forEach(value => {
        params.append("langs_id[]", value);
      });
    }
    if(filters.note.length){
      params.append("note", filters.note[0]);
    }

    params.append("hideExpName", this.wrapper.dataset.hideExpName);
    params.append("clickableReviewImages", this.wrapper.dataset.clickableReviewImages ?? 'true');

    //compare to previous filters, if they are the same, triggering a filter is useless
    if(this.previousUrlWithParams != '' && this.previousUrlWithParams === url.toString()){
      return;
    }

    //update the active filters count on the button
    this.updateActiveFiltersCount(filters);

    if(this.filterButton){
      this.filterButton.disabled = true; //disable the submit button to prevent spam
      this.filterButton.classList.add('loading');
    }
    if(this.overlayLoading){
      this.overlayLoading.classList.remove('hidden'); //show the overlay indicating the loading
    }
    ajax(url.toString(), (html) => {
      if(this.reviewsContainer){
        this.reviewsContainer.innerHTML = html;

        //init again the pagination
        this.initPagination();

        //save filters
        this.previousUrlWithParams = url.toString();

        //init offuscation for experiences links
        initOffuscation(this.reviewsContainer);

        //since reviews might contain reviews with pictures
        //init modal & swiper logic
        Modal.bindAllModals();
        initSwiper(this.reviewsContainer);
      }

      if(this.filterButton){
        this.filterButton.disabled = false;
        this.filterButton.classList.remove('loading');
      }
      if(this.overlayLoading){
        this.overlayLoading.classList.add('hidden');
      }

      if(this.filterButton){
        Drawer.closeDrawer(this.filterButton.closest('.drawer'));
      }
    }, 'GET', {}, {}, true, false);
  }

  onPreviousOrNextClick(type){
    if(type === 'next'){
      var num = parseInt(this.activePage.dataset.num) + 1;
    } else {
      var num = parseInt(this.activePage.dataset.num) - 1;
    }
    const page = this.pagination.querySelector(".page[data-num='"+ num +"']"); //get previous or next page
    if(page){
      page.dispatchEvent(new Event('click'));
    }
  }


  /**
   * Handles the click event of the translate button.
   *
   * @param {} - No parameters.
   * @return {} - No return value.
   */
  onTranslateButtonClick(){
    if(this.translateReviewsButton.dataset.state == 'readyToTranslate'){
      this.wrapper.dataset.translateToLocale = document.body.dataset.lang;

      this.translateReviewsButton.textContent = this.translateReviewsButton.dataset.back;
      this.translateReviewsButton.dataset.state = 'backToOriginal';

      if(this.translatedByGoogleNotice) this.translatedByGoogleNotice.classList.remove('hidden');
    }
    else {
      delete this.wrapper.dataset.translateToLocale;

      this.translateReviewsButton.textContent = this.translateReviewsButton.dataset.trad;
      this.translateReviewsButton.dataset.state = 'readyToTranslate';

      if(this.translatedByGoogleNotice) this.translatedByGoogleNotice.classList.add('hidden');
    }

    this.fetchReviews(
      this.wrapper.dataset.experienceId ?? 0,
      this.wrapper.dataset.hostId ?? 0,
      this.wrapper.dataset.giftPackageId ?? 0,
      this.activePage ? this.activePage.dataset.num : '1'
    );
  }

  initViewHostReply(){
    window.addEventListener('click', (e) => {
      if(e.target.classList.contains('show-host-reply')){
        const showReplyButton = e.target;

        //find and show the host reply
        const hostReply = this.wrapper.querySelector(`.host-reply-${showReplyButton.dataset.reply}`);
        if(hostReply){
          if(showReplyButton.dataset.textToSwitch === 'hideReply'){
            showReplyButton.textContent = showReplyButton.dataset.hideReplyText;
            showReplyButton.dataset.textToSwitch = 'showReply';

            hostReply.classList.add('opened');
          }
          else{
            showReplyButton.textContent = showReplyButton.dataset.showReplyText;
            showReplyButton.dataset.textToSwitch = 'hideReply';

            hostReply.classList.remove('opened');
          }
        }
      }
    });
  }

  initSortBy(){
    if(!this.reviewsDrawer){
      return;
    }

    const sortByInputs = this.reviewsDrawer.querySelectorAll("[name='sort_by']");
    sortByInputs.forEach(input => {
      input.addEventListener('change', () => {
        if(input.checked){
          this.sortBy = input.value;
        }
      });
    });
  }

  /**
   * Updates the UI with the count of active filters.
   *
   * @param {object} filters - The filters object containing the types of experience, languages, and notes.
   */
  updateActiveFiltersCount(filters){
    if(!this.activeFiltersBadge){
      return;
    }

    let countActiveFilters = filters.typesOfExperiences.length > 0 ? 1 : 0;
    countActiveFilters = filters.langs.length > 0 ? countActiveFilters + 1 : countActiveFilters;
    if(filters.note[0] !== 'all'){
      countActiveFilters++;
    }

    this.activeFiltersBadge.classList.toggle('hidden', countActiveFilters === 0);
    this.activeFiltersBadge.textContent = countActiveFilters;
  }

}

export default ReviewsFiltering;
